<template>
    <div>
        <!--right floating window-->
        <div class="r-contact">
            <div class="r-c-slide" id="gotop" title="回到顶部">
                <img src="/static/images/icon-r-gotop.png" />
            </div>
            <div class="r-c-slide">
                <img src="/static/images/icon-r-phone.png" />
                <div class="r-c-box">
                    <h6>联系电话</h6>
                    <p>{{ profile.telephone }}</p>
                </div>
            </div>
            <div class="r-c-slide">
                <img src="/static/images/icon-r-email.png" />
                <div class="r-c-box">
                    <h6>联系邮箱</h6>
                    <p class="r-eamil">{{ profile.email }}</p>
                </div>
            </div>
            <div class="r-c-slide">
                <img src="/static/images/icon-r-wx.png" />
                <div class="r-c-box">
                    <img :src="profile.officialDimensionCodeAddress" />
                </div>
            </div>
            <div class="r-c-slide" v-if="showImg == 1">
                <img src="/static/images/icon-qywx.png" />
                <div class="r-c-box">
                    <img src="/static/images/icon-qywx-wang.jpg" />
                </div>
            </div>

        </div>
        <div class="r-kefu" href="javascript:void(0)" @click="showKefu()">
            <img src="/static/images/r-udsk.png"/>
            <h6>在线咨询</h6>
        </div>

    </div>
</template>
<script>
import "../../../static/css/studentindex.css";
export default {
    props:{
        profile:{//中心简介，包含邮箱联系方式等信息
            type:Object,
        },
    },
    data() {
        return {
            showImg: 1
        }
    },
    watch: {},
    methods: {
        //点击展开客服
        showKefu(){
            $('#udesk_btn_text').trigger('click');
        },
        //组装udsk在线客服
        buildUdsk(a, h, c, b, f, g){
            a["UdeskApiObject"] = f;
            a[f] = a[f] || function() {
                (a[f].d = a[f].d || []).push(arguments)
            };
            g = h.createElement(c);
            g.async = 1;
            g.charset = "utf-8";
            g.src = b;
            c = h.getElementsByTagName(c)[0];
            c.parentNode.insertBefore(g, c)
        },
    },
    created() {
        //在线客服配置
        this.buildUdsk(window, document, "script", "https://assets-cli.s4.udesk.cn/im_client/js/udeskApi.js", 'ud');
        ud({
            "code": "2jhbcbc",
            "link": "https://clkefu.s4.udesk.cn/im_client/?web_plugin_id=4296"
        });
        document.write('<style>#udesk_btn{display: none;}</style>');
    },
    mounted() {
        var domain = window.location.hostname
        // 1四川2海南 hnjnrd.scjxjypx.com
        if (domain == "hnjnrd.scjxjypx.com") {
            this.showImg = 2
        }
    }

}
</script>



// WEBPACK FOOTER //
// src/views/common/RdRight.vue